import { FC } from 'react';

import { Icon } from '@purpur/library/icon';

import { getSvgIcon } from '@telialt/common-icon/src';

import { PLAN_CARD_TEST_ID } from '../constants';
import { PlanCardModel } from '../model';
import { CardCap } from '../PlanCard.styles';

export const Cap: FC<PlanCardModel.CapProps> = ({ text, variant, icon, image }) => {
    if (!text) {
        return <div />;
    }
    const svg = getSvgIcon(icon);

    return (
        <CardCap $variant={variant} data-test={PLAN_CARD_TEST_ID.CAP}>
            {image && <img src={image} alt="" aria-hidden="true" />}
            {icon && <Icon size="md" svg={svg} aria-hidden="true" />}
            {text}
        </CardCap>
    );
};
